import { Github, Heart } from 'lucide-react'

export default function Header() {
  return (
    <header className="glass-card border-b border-white/10 sticky top-0 z-50 backdrop-blur-xl">
      <div className="container mx-auto px-4 py-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="bg-gradient-to-br from-brand-500 to-accent-500 p-2 rounded-xl shadow-lg">
              <img src="/logo.svg" alt="Logo" className="w-6 h-6 invert" />
            </div>
            <span className="text-2xl font-black gradient-text">Domain Brainstorm</span>
          </div>
          
          <nav className="hidden md:flex items-center space-x-8">
            <a 
              href="#features" 
              className="text-slate-600 hover:text-brand-600 transition-all duration-300 font-medium hover:scale-105"
            >
              Features
            </a>
            <a 
              href="#how-it-works" 
              className="text-slate-600 hover:text-brand-600 transition-all duration-300 font-medium hover:scale-105"
            >
              How It Works
            </a>
            <a 
              href="https://github.com/yourusername/domain-brainstorm" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center space-x-2 text-slate-600 hover:text-brand-600 transition-all duration-300 font-medium hover:scale-105"
            >
              <Github className="w-4 h-4" />
              <span>GitHub</span>
            </a>
            <div className="bg-gradient-to-r from-brand-500 to-accent-500 text-white px-4 py-2 rounded-full text-sm font-semibold shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer hover:scale-105">
              🚀 100% Free
            </div>
          </nav>
          
          <div className="flex items-center space-x-3">
            <div className="hidden sm:flex items-center space-x-2 text-sm text-slate-500 font-medium">
              <Heart className="w-4 h-4 text-red-400 animate-bounce-subtle" />
              <span>Made with love</span>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}
